<template>
  <div class="web_widget_v2 narrow_strip">

    <div class="pg_sec">
      <div class="career_prospect_detail">

        <template v-if="demoWidget">
          <div class="row hd_sec">
            <div class="col-12 hd ace_sec_hd job_posting_sec_hd" aria-label="Job Posting Overview" style="padding-right: 0px;">
              <div class="row">
                <div class="col-12 hd_txt">
                  <div class="row align-items-center" style="height: 60px;">
                    <div class="col-8">
                      <h2>Job Outlook:</h2>
                    </div>
                    <div class="col-4">
                      Showing US Data.
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 entity_select">
                  <template v-if="$parent.majorsToShow && $parent.majorsToShow.length > 0">
                    <div class="row">
                      <div class="col-3 label_bx">
                        <div class="row align-items-center" style="height: 60px;">
                          <div class="col-12">
                            <label>
                              <span class="select">select </span>
                              <span class="programLabel">{{$parent.programLabel}}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="col-9 select_bx">
                        <div class="row align-items-center" style="height: 60px;">
                          <div class="col-12">
                            <v-select class="select-field" v-model="$parent.selectedMajor"
                            :options="$parent.majorsToShow" label="name" :placeholder="'Select Any ' + $parent.programLabel" :clearable="false"></v-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="row hd_sec">
            <div class="col-xl-3 col-lg-4 col-md-12 col-sm-12 hd ace_sec_hd job_posting_sec_hd" aria-label="Job Posting Overview" style="padding-right: 0px;">
              <h2>Job Outlook:</h2>
            </div>
            <div class="col-xl-9 col-lg-8 col-md-12 col-sm-12 lnk_explore_regions">
              Showing {{selectedDataInfo}} Data. <a href="javascript://" @click="exploreRegionalDataClicked">Explore other regions.</a>
            </div>
          </div>

          <div class="row pg_txt_row mb-4" v-if="$parent.majorsToShow && $parent.majorsToShow.length > 0">
            <div class="col-12 entity_select">
              <div class="row">
                <div class="col-12 label_bx">
                  <label>
                    <span class="select">select </span>
                    <span class="programLabel">{{$parent.programLabel}}</span>
                  </label>
                </div>
                <div class="col-12 select_bx">
                  <v-select class="select-field" v-model="$parent.selectedMajor"
                  :options="$parent.majorsToShow" label="name" :placeholder="'Select Any ' + $parent.programLabel" :clearable="false"></v-select>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- Start Alumni Data -->
        <div class="row list_view" v-if="showAlumniDataOnWidgetIsEnabled">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="row pg_sec" style="padding-bottom: 0px;">
              <div class="col-12 sec_content">
                <div class="row result_row" style="border-bottom: none; margin-bottom: 5px;" v-if="spotlightAlumni">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12">
                        <h6><strong>{{spotlightAlumni.title}}{{getClassOf(spotlightAlumni)}}</strong></h6>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 thumbnail_section">
                    <div class="thumbnail_container ace_sec">
                      <div class="thumbnail_img" v-if="spotlightAlumni.thumbnailURI">
                        <img v-bind:src="spotlightAlumni.thumbnailURI">
                      </div>
                      <div class="thumbnail" v-else>
                        <div class="person_thumbnail">
                          <div class="thumbnail_container">
                            <div class="default">
                              <div class="thumbnail">
                                <div class="ic thumbnail_icon icon-mentor" style="color: #787878;"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-5 col-sm-8 entity_detail_section">
                    <div class="row">
                      <div class="col-12 description ace_sec_txt" id="biography" v-if="spotlightAlumni.biography">
                         <span class="desc_txt" v-html="spotlightAlumni.biography"></span>
                      </div>
                      <div class="col-12 no_description empty_pattern ace_sec_txt" v-else>
                        Biography not added
                      </div>
                      <template v-if="spotlightAlumni.biography && spotlightAlumni.biography.length > 100">
                        <div class="col-12">
                          <span class="float-right" style="cursor: pointer; color: #0645AD;" @click="expandCollapseBio" id="more-less">{{getMoreLessLabel()}}</span>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div v-if="showCareerEmoloyerJob">
                  <h6><strong>Alumni Data</strong></h6>
                </div>
                <div class="row content_sec jobs_outlook national_data" v-if="showCareerEmoloyerJob">
                  <div class="card col-4" v-if="alumniData && alumniData.topCareerTitle">
                    <div class="card-body">
                      <template>
                        <div class="crd_data" :aria-label="'Most Popular Alumni Career ' + alumniData.topCareerTitle">
                          <div class="row">
                            <template v-if="alumniData.topCareerThumbnail">
                              <div class="col-12 text-center" style="top: -5px;">
                                <div v-if="alumniData.topCareerThumbnail">
                                  <img v-bind:src="alumniData.topCareerThumbnail" style="height: 50px; width: 50px;">
                                </div>
                              </div>
                            </template>
                            <div class="col-12 text-center">
                              <h6 style="color: #6eacc8;"><strong>{{alumniData.topCareerTitle}}</strong></h6>
                            </div>
                          </div>
                        </div>
                        <div class="crd_title">
                          <span class="title_txt">
                            <span class="txt_1">Most Popular Alumni Career</span>
                         </span>
                        </div>
                      </template>
                    </div>
                  </div>

                  <div class="card col-4" v-if="alumniData && alumniData.topCompanyTitle">
                    <div class="card-body">
                      <template >
                        <div class="crd_data" :aria-label="'Company with most alumni ' + alumniData.topCompanyTitle">
                          <div class="row">
                            <div class="col-12 text-center">
                              <h6><strong>{{alumniData.topCompanyTitle}}</strong></h6>
                            </div>
                          </div>
                        </div>
                        <div class="crd_title">
                          <span class="title_txt">
                            <span class="txt_1">Company with most alumni</span>
                         </span>
                        </div>
                      </template>
                    </div>
                  </div>

                  <div class="card col-4" v-if="alumniData && alumniData.totalHireLastYearHire" >
                    <div class="card-body">
                      <template>
                        <div class="crd_data" :aria-label="'Number of hires last year ' + alumniData.totalHireLastYearHire">
                          <div class="row">
                            <div class="col-12 text-center">
                              <h6 style="color: #6eacc8;"><strong>{{alumniData.totalHireLastYearHire}}</strong></h6>
                            </div>
                          </div>
                        </div>
                        <div class="crd_title">
                          <span class="title_txt">
                            <span class="txt_1">Number of hires last year</span>
                         </span>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <!--
                <div class="row float-right" v-if="showCareerEmoloyerJob">
                  <span style="font-weight: 600;">Learn about alumni companies and careers</span>
                </div>
                -->
              </div>
            </div>
          </div>
        </div>
        <!-- End Alumni Data> -->

        <!--
        <div class="row pg_txt_row">
          <div class="col-12">
            Below is US National Career Data.
            <a href="javascript://" @click="exploreRegionalDataClicked">Explore Career Data for your region.</a>
          </div>
        </div>


         <div class="row content_sec jobs_outlook national_data">

           <div class="card col-4 salary">
             <div class="card-body">
               <div class="crd_data">
                 <div class="crd_data_inner" v-if="formattedCareer && formattedCareer.aggregatedMedianHourlyEarning" :aria-label="'Median Income $ ' + addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)">
                   <div class="ic_container">
                     <div class="ic ic8-salary"></div>
                   </div>
                   <div class="values">
                     <div class="main_val_1">
                       <div class="val_1_txt salary" v-html="'$' + addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></div>
                     </div>
                     <div class="add_val" v-if="formattedCareer.aggregatedMaxIncome">
                       hi - $<span v-html="addCommaInNumber(formattedCareer.aggregatedMaxIncome)"></span>
                     </div>
                     <div class="add_val" v-if="formattedCareer.aggregatedMinIncome">
                       low - $<span v-html="addCommaInNumber(formattedCareer.aggregatedMinIncome)"></span>
                     </div>
                   </div>
                </div>
               </div>
               <div class="crd_title">
                 <span class="title_txt">
                   <span class="ic">
                     <span class="ic8-salary"></span>
                   </span>
                   <span class="txt">
                     <span class="txt_1">Median </span>
                     <span class="txt_2">Income</span>
                   </span>
                 </span>
               </div>
             </div>
           </div>

           <div class="card col-4">
             <div class="card-body">
               <template v-if="formattedCareer && formattedCareer.aggregatedGrowthPercentage">
                 <div class="crd_data" :aria-label="'Estimated Job Growth ' + formattedCareer.timeframe + ' ' + formattedCareer.aggregatedGrowthPercentage + '%'">
                   <div class="row">
                     <div class="col-xl-7 col-lg-6 col-md-12 col-sm-12 chart_container">
                       <div class="row legend">
                         <div class="col-6 lg_lft">0%</div>
                         <div class="col-6 lg_rgt">15%</div>
                       </div>
                       <div class="gph_chart gph_pie_chart">
                         <doughnut-chart :chart-data="growthPieData" id="gauge" :options="growthPieOptions" @afterComplete="callDrawNeedle('gauge', formattedCareer.aggregatedGrowthPercentage)"></doughnut-chart>
                       </div>
                     </div>
                     <div class="col-xl-5 col-lg-6 col-md-12 col-sm-12 main_val_1 gph_val">
                       <span class="val_1_txt" v-html="(Math.round(formattedCareer.aggregatedGrowthPercentage * 100) / 100).toFixed(1)"></span><span>%</span>
                     </div>
                   </div>
                 </div>
                 <div class="crd_title">
                   <span class="title_txt">
                     <span class="txt_1">Estimated Job Growth </span>
                     <span class="txt_2">{{formattedCareer.timeframe}}</span>
                  </span>
                 </div>
               </template>
             </div>
           </div>

           <div class="card col-4 postings">
             <div class="card-body">
               <div class="crd_data">
                 <div class="crd_data_inner" v-if="formattedCareer && formattedCareer.aggregatedLastYearJob" :aria-label="'job postings in the last 12 months ' + addCommaInNumber(formattedCareer.aggregatedLastYearJob)">
                   <div class="ic_container">
                     <div class="ic ic8-job2"></div>
                   </div>
                   <div class="values">
                     <div class="main_val_1">
                       <span class="val_1_txt" v-html="formatNumericVal(formattedCareer.aggregatedLastYearJob)"></span>
                     </div>
                   </div>
                </div>
               </div>
               <div class="crd_title">
                 <span class="title_txt">
                   <span class="ic">
                     <span class="ic8-job2"></span>
                   </span>
                   <span class="txt">
                     <span class="txt_1">Job Postings </span>
                     <span class="txt_2">{{formattedCareer.endYear - 1}} - {{formattedCareer.endYear}} </span>
                   </span>
                 </span>
               </div>
             </div>
           </div>

         </div>
         <!-- ## end job outlook ## -->

         <div class="row hd_sec" style="margin-bottom: 0px;">
           <div class="col-12 hd ace_sec_hd" aria-label="Careers">
             <h2>Careers</h2>
           </div>
          </div>


        <div class="row content_sec sec_careers">
          <div class="col-12" v-if="formattedCareers && formattedCareers.length > 0">
            <div class="row list_view">
              <div class="col-12 accordion" role="tablist">
                <div class="row result_row" v-for="(career, i) in formattedCareers" v-if="i < 5" style="padding-bottom: 0px; margin-bottom: 0px;">

                  <b-card no-body class="accordion-sec" :id="'accordionSec_' + i" :class="i == 0 ? 'active' : ''">
                    <b-card-header class="crd_hd" header-tag="header" role="tab">
                      <b-button class="accordion_hd_btn" v-b-toggle="'detail-' + i" variant="info" @click="expandCareer(i, career)">
                        <div class="row accordion_head2" style="width: 100%;" :id="'info-' + i">
                          <div class="col-2 thumbnail_section">
                            <div class="thumbnail_container ace_sec" style="height: 50px; width: 50px;">
                              <div class="thumbnail_img" v-if="career.thumbnailUrl">
                                <img v-bind:src="career.thumbnailUrl" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
                              </div>
                              <div class="thumbnail" v-else>
                                <div class="txt_bx txt_bx_1" :id="setTitleBoxWidth(career.name, 'thumb_' + i)" v-html="setTitleInitials(career.name)"></div>
                              </div>
                            </div>
                          </div>
                          <div class="col-10 entity_detail_section" :class="updateTitleHeight(i)">
                            <div class="row">
                              <div class="col-12 title_row">
                                <span class="title ace_sec_txt" :id="'entityName_' + i" :aria-label="career.name">{{career.name}}</span>
                                <button :id="'expand-' + i" class="btn_ic ic ic8-circle-down"></button>
                                <span v-if="showAlumniDataOnWidgetIsEnabled && (career.name === alumniData.topCareerTitle)" class="title ace_sec_txt alumni-career-label" style="font-size: small; position: relative; top: 4px;">alumni career</span>
                              </div>
                            </div>
                          </div>
                        </div>

                      </b-button>
                    </b-card-header>

                    <b-collapse :id="'detail-' + i" class="career_detail_panel" accordion="career-accordion" role="tabpanel">

                      <div class="row expanded">
                        <div class="col-2 thumbnail_section">
                          <div class="thumbnail_container ace_sec">
                            <div class="thumbnail_img" v-if="career.thumbnailUrl">
                              <img v-bind:src="career.thumbnailUrl" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
                            </div>
                            <div class="thumbnail" v-else>
                              <div class="txt_bx" :id="setTitleBoxWidth(career.name, 'thumb_' + i)" v-html="setTitleInitials(career.name)"></div>
                            </div>
                          </div>
                        </div>

                        <div class="col-10 entity_detail_section" :class="updateTitleHeight(i)">
                          <div class="row">
                            <div class="col-12 title_row">
                              <div class="title ace_sec_txt" :id="'entityName_' + i" :aria-label="career.name">{{career.name}}</div>
                              <span class="title ace_sec_txt" v-if="showAlumniDataOnWidgetIsEnabled && (career.name === alumniData.topCareerTitle)">
                                <span class="alumni-career-label" style="font-size: small;">alumni career</span>
                              </span>
                              <button class="btn_ic ic ic8-circle-up" v-b-toggle="'detail-' + i" variant="info" @click="collapseCareer(i)"></button>
                            </div>
                            <div class="col-12 description ace_sec_txt" :id="'entityDesc_' + i" v-if="career.description">
                              <span class="desc_txt">{{ career.description }}</span>
                            </div>
                            <div class="col-12 no_description empty_pattern ace_sec_txt" aria-label="No description added for this career" v-else>
                              No description added for this career
                            </div>
                          </div>
                        </div>
                      </div>


                      <div class="row sec_content jobs_outlook">

                        <div class="card col-4 salary">
                          <div class="card-body">
                            <div class="crd_data">
                              <div class="crd_data_inner" v-if="career.medianHourlyEarning" :aria-label="'median income is ' + career.medianHourlyEarning">
                                <div class="ic_container">
                                  <div class="ic ic8-salary"></div>
                                </div>
                                <div class="values">
                                  <div class="main_val_1">
                                    <div class="val_1_txt salary" v-html="'$' + addCommaInNumber(career.medianHourlyEarning)"></div>
                                  </div>
                                  <div class="add_val" v-if="career.maxIncome">
                                    hi - $<span v-html="addCommaInNumber(career.maxIncome)"></span>
                                  </div>
                                  <div class="add_val" v-if="career.minIncome">
                                    low - $<span v-html="addCommaInNumber(career.minIncome)"></span>
                                  </div>
                                </div>
                              </div>
                              <div v-else aria-label="median income is not available for this career">N/A</div>
                            </div>
                            <div class="crd_title">
                              <span class="title_txt">
                                <span class="ic">
                                  <span class="ic8-salary"></span>
                                </span>
                                <span class="txt">
                                  <span class="txt_1">Median </span>
                                  <span class="txt_2">Income</span>
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="card col-4">
                          <div class="card-body">
                            <div class="crd_data">
                              <div v-if="career.growth" :aria-label="'Growth rate is ' + career.growth + '% for this career'">
                                <div class="row">
                                  <div class="col-6 chart_container">
                                    <div class="row legend">
                                      <div class="col-6 lg_lft">0%</div>
                                      <div class="col-6 lg_rgt">15%</div>
                                    </div>
                                    <div class="gph_chart gph_pie_chart">
                                      <doughnut-chart :chart-data="growthPieData" :id="'career-gauge-' + i" :options="growthPieOptions" @afterComplete="callDrawNeedle('career-gauge-' + i, career.growth)"></doughnut-chart>
                                    </div>
                                  </div>
                                  <div class="col-6 main_val_1 gph_val">
                                    <span class="val_1_txt" v-html="(Math.round(career.growth * 100) / 100).toFixed(1)"></span><span>%</span>
                                  </div>
                                </div>
                              </div>
                              <div v-else aria-label="growth rate is not available for this career">N/A</div>
                            </div>
                            <div class="crd_title">
                              <span class="title_txt">
                                <span class="txt_1">Estimated Job Growth</span>
                                <span class="txt_2">{{career.timeframe}}</span>
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="card col-4 postings">
                          <div class="card-body">
                            <div class="crd_data">
                              <div class="crd_data_inner" v-if="career.annualOpening" :aria-label="'job postings in the last 12 months ' + addCommaInNumber(career.annualOpening)">
                                <div class="ic_container">
                                  <div class="ic ic8-job2"></div>
                                </div>
                                <div class="values">
                                  <div class="main_val_1">
                                    <span class="val_1_txt" v-html="formatNumericVal(career.annualOpening)"></span>
                                  </div>
                                </div>
                              </div>
                              <div v-else aria-label="job postings is not available for this career">N/A</div>
                            </div>
                            <div class="crd_title">
                              <span class="title_txt">
                                <span class="ic">
                                  <span class="ic8-job2"></span>
                                </span>
                                <span class="txt">
                                  <span class="txt_1">Job Postings </span>
                                  <span class="txt_2">{{career.year - 1}}-{{career.year}}</span>
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>


                      <div class="row tp_comp_sec" v-if="isBGTFeatureEnabled && career.companies.length > 0">
                        <div class="col-12">
                          <div class="row mb-2">
                            <h6><strong>Top Companies that are hiring</strong></h6>
                          </div>
                          <div class="row tp_comp_row" v-for="(company, j) in career.companies" v-if="j < 2">
                            <div class="col-xl-8 col-lg-8 col-md-6 col-sm-12 val title">
                              {{company.name}}
                            </div>
                            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 val count">
                              <span>{{addCommaInNumber(company.total_postings)}} jobs</span>
                            </div>
                          </div>
                          <div class="row" v-if="career.companies.length > 2">
                            <div class="col-12 more_lnk_container">
                              <a href="javascript://" @click="moreCompaniesClicked">{{career.companies.length - 2}} more companies</a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row sec_action">
                        <div class="col-12">
                          <b-button class="lg" @click="fullCareerReportClicked(career.code)" aria-label="get full career report">Get Full Career Report</b-button>
                        </div>
                      </div>


                    </b-collapse>
                  </b-card>

                </div>
              </div>
            </div>
            <div class="col-12 mt-2" style="height: 40px;">
              <div class="float-left">
                <a href="javascript://" style="font-size: large;" @click="askAdvisor" v-if="showAskAdvisorOnWidgetIsEnabled">Ask Advisor</a>
              </div>
              <div class="float-right">
                <a href="javascript://" class="float-right" style="font-size: large;" @click="moreCareersClicked">Explore More Careers</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading-spinner">
      <b-modal id="webWidgetLoadingModal" style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF; overflow: hidden;">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

    <div class="modal_popup_container">
      <b-modal id="userVerificationPopup" ref="newFormModal" centered hide-footer class="usr_verification_popup" no-close-on-backdrop>

        <div slot="modal-header" class="header-section">
          <div class="head_txt">
            <template v-if="!showRestOfTheForm">
              Get Your Career Report
            </template>
            <template v-if="showRestOfTheForm">
              Personalize Your Experience!
            </template>
          </div>
          <div class="btn_container">
            <button class="btn_close" aria-label="close" @click="registerProspectiveStudent">
            <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row">

          <div class="col-1 lft_col"></div>

          <div class="col-10 mid_col">
            <template v-if="!showRestOfTheForm">

              <div class="row">

                <div class="col-6 intro_msg">
                  <template v-if="introductionMessage">
                    <p>{{introductionMessage}}</p>
                  </template>
                </div>

                <div class="col-6 frm_container">
                  <div class="form_col">

                    <div class="row error_msg_sec">
                      <div class="col-12">
                        <span v-if="newProspectError" class="text-danger" v-html="newProspectError"></span>
                      </div>
                      <div class="col-12">
                        <span v-if="demoWidgetMessage" class="text-danger">This is a demo widget</span>
                      </div>
                    </div>

                    <div class="row page_fld_section fld_email">
                      <div class="col-12 fld-label" id="eMail">
                        Email <sup>*</sup>
                      </div>
                      <div class="col-12 fld_input">
                        <b-form-input type="email" v-model.email="newForm.eMail"  placeholder="email">
                        </b-form-input>
                      </div>
                    </div>

                    <div class="row popup_btn_container">
                      <div class="col-12 popup_btn">
                        <template v-if="!demoWidget">
                          <b-button size="lg" @click="continueToRegistrationForm()" :disabled="!isContinueEnabled" aria-label="verify">Continue</b-button>
                        </template>
                        <template v-else>
                          <b-button size="lg" @click="showDemoWidgetMessage()" :disabled="!isContinueEnabled" aria-label="verify">Continue</b-button>
                        </template>
                      </div>
                    </div>

                  </div>
                </div>

              </div>

              <div class="row">
                <div class="col-6 popup_content">

                  <template v-if="newForm.action === 'ExploreRegionalData'">
                    <div class="popup_txt">
                      The <span class="bd">program report</span> includes information such as:
                    </div>
                    <div class="popup_lst">
                      <ul>
                        <li>Career prospects for this program in your region</li>
                        <li>Salaries from typical careers</li>
                        <li>Companies who are hiring in your region</li>
                        <li>Number of job posts</li>
                      </ul>
                    </div>
                  </template>
                  <template v-if="newForm.action === 'FullCareerReport'">
                    <div class="popup_txt">
                      The <span class="bd">Pragya career report</span> will help you learn everything about a career, including information like:
                    </div>
                    <div class="popup_lst">
                      <ul>
                        <li>Salaries</li>
                        <li>Companies who are hiring in your region</li>
                        <li>Number of job posts</li>
                        <li>Skills that employers are looking for</li>
                      </ul>
                    </div>
                  </template>
                  <template v-if="newForm.action === 'OtherCompanies'">
                    <div class="popup_txt">
                      You can find the top companies hiring for this career in the <span class="bd">Pragya career report</span>. The report also includes information like:
                    </div>
                    <div class="popup_lst">
                      <ul>
                        <li>Salaries</li>
                        <li>Companies who are hiring in your region</li>
                        <li>Number of job posts</li>
                        <li>Skills that employers are looking for</li>
                      </ul>
                    </div>
                  </template>
                  <template v-if="newForm.action === 'OtherCareers'">
                    <div class="popup_txt">
                      You can find all prospective careers for this program in the <span class="bd">program report</span>. The report also includes information like:
                    </div>
                    <div class="popup_lst">
                      <ul>
                        <li>Career prospects after education for this program</li>
                        <li>Salaries from typical careers</li>
                        <li>Companies who are hiring in your region</li>
                        <li>Number of job posts</li>
                      </ul>
                    </div>
                  </template>
                  <template v-if="newForm.action === 'ThirdCareer'">
                    <div class="popup_txt">
                      You can find all prospective careers for this program in the <span class="bd">program report</span>. The report includes information like:
                    </div>
                    <div class="popup_lst">
                      <ul>
                        <li>Career prospects after education for this program</li>
                        <li>Salaries from typical careers for this program</li>
                        <li>Companies who are hiring in your region</li>
                        <li>Number of job posts</li>
                      </ul>
                    </div>
                  </template>

                </div>
              </div>

            </template>
            <template v-if="showRestOfTheForm">
              <div class="row">

                <div class="col-5 intro_msg">
                  <template v-if="introductionMessage">
                    <p>{{introductionMessage}}</p>
                  </template>
                  <div class="" style="margin-top: 0px;">
                    <p>Providing more information will help us personalize your exploration experience. </p>
                    <p>Your data is completely secure. Read our <a href="https://site.pragyasystems.com/privacy-policy/" target="_blank">Privacy Policy</a> </p>
                  </div>
                </div>

                <div class="col-1"></div>

                <div class="col-6 frm_container" @keydown.enter="login">

                  <div class="row error_msg_sec">
                    <div class="col-12">
                      <span v-if="newProspectError" class="text-danger" v-html="newProspectError"></span>
                    </div>
                  </div>

                  <div class="row page_fld_section">
                    <div class="col-12 fld-label" id="firstName">
                      First Name
                    </div>
                    <div class="col-12 fld_input">
                      <b-form-input type="text" v-model.trim="newForm.firstName" placeholder="First Name">
                      </b-form-input>
                    </div>
                  </div>
                  <div class="row page_fld_section">
                    <div class="col-12 fld-label" id="lastName">
                      Last Name
                    </div>
                    <div class="col-12 fld_input">
                      <b-form-input type="text" v-model.trim="newForm.lastName" placeholder="Last Name">
                      </b-form-input>
                    </div>
                  </div>
                  <div class="row page_fld_section" v-if="showPhoneNumberOnWidgetIsEnabled">
                    <div class="col-12 fld-label" id="primaryPhoneNumber">
                      Phone Number
                    </div>
                    <div class="col-12 fld_input">
                      <b-form-input type="text" v-model.trim="newForm.primaryPhoneNumber" placeholder="Phone Number">
                      </b-form-input>
                    </div>
                  </div>
                  <div class="row page_fld_section" v-if="showTermOnWidgetIsEnabled && availableTerms.length !== 0">
                    <div class="col-12 fld-label" id="selectedTerm">
                      Terms
                    </div>
                    <div class="col-12 fld_input">
                        <b-form-select v-model="newForm.selectedTerm" :options="availableTerms" :disabled="(availableTerms.length === 0)"></b-form-select>
                    </div>
                  </div>
                  <div class="row popup_btn_container">
                    <div class="col-6 pragya_login_lnk">
                      <b-link @click="registerProspectiveStudent()" target="_blank">No Thanks. Just send me the report.</b-link>
                    </div>
                    <div class="col-6 popup_btn">
                      <b-button size="lg" @click="registerProspectiveStudent()" :disabled="!isUnlockEnabled" aria-label="verify">Done</b-button>
                    </div>
                  </div>
                </div>

              </div>
            </template>
          </div>
        </div>
      </b-modal>
    </div>

    <div class="modal_popup_container">
      <b-modal id="userVerificationPopupThankYou" ref="thankYouModal" centered hide-footer class="usr_verification_popup_thankyou" no-close-on-backdrop>
        <div slot="modal-header" class="header-section">
          <div class="head_txt">
            Thank you!
          </div>
          <div class="btn_container">
            <button class="btn_close" aria-label="close" @click="closeThankYouModalBox">
            <span class="ic-close"></span>
            </button>
          </div>
        </div>
        <div class="row pt-3">
            <div class="col-1 lft_col"></div>
            <div class="col-10 content_col">
              <p>Your report is on its way.</p>
              <p>Please check your bulk mail or spam folders if you don't see it in your inbox.</p>
              <p><a href="mailto:support@pragyasystems.com">Questions?</a> We are here to help!

              </p>
            </div>
        </div>
        <div class="row popup_btn_container">
          <div class="col-11 popup_btn" style="text-align: right;">
            <b-button size="lg" @click="closeThankYouModalBox()" aria-label="OK">OK</b-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueCookies from 'vue-cookies'
  import { mapState, mapActions } from 'vuex'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
  import DoughnutChart from './DoughnutChart'
  import { StorageFactory } from '../../../storageFactory'
  import _ from 'lodash'
  Vue.use(VueCookies)
  Vue.$cookies.config('1m')

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'widget-program-guide-career-prospects-detail',
    props: ['cipCode', 'programGuideCode', 'institutionId', 'majorTitle', 'introductionMessage', 'demoWidget', 'isWidgetAdminDash', 'state', 'msa'],
    components: {
      DoughnutChart
    },
    data: () => {
      return {
        alumniData: {},
        clickCount: 0,
        selectedState: '',
        selectedMetroArea: '',
        selectedCounty: '',
        careerMinIncome: '',
        careerMaxIncome: '',
        disableSelectState: false,
        disableSelectMetroArea: false,
        disableSelectCounty: false,
        isSalaryBoostSkill: false,
        demoWidgetMessage: false,
        targetOccupationItems: [],
        topCompaniesItems: [],
        topSkillsFields: ['Skill', 'Postings_with_Skill'],
        topSkillsItems: [],
        growthPieOptions: {
          rotation: 1 * Math.PI,
          cutoutPercentage: 40,
          circumference: 1 * Math.PI,
          tooltips: {
            enabled: false
          }
        },
        newForm: {
          eMail: '',
          firstName: '',
          lastName: '',
          major1: '',
          major1CipCode: '',
          major1Title: '',
          primaryPhoneNumber: '',
          selectedTerm: null,
          status: null,
          action: null,
          socCode: ''
        },
        showRestOfTheForm: false,
        loginUrl: window.location.origin,
        newProspectError: '',
        isCareerGraphExpanded: false,
        selectedDataInfo: 'US',
        accordionCareerIndex: null,
        reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      }
    },
    async beforeMount () {
      this.alumniData = await this.loadProgramAlumniData(this.programGuideCode)
    },
    async mounted () {
      this.resetData()
      await this.loadDataForProgramGuideCareerProspects()
      this.$nextTick(() => {
        setTimeout(() => {
          $('#expand-0').click()
        }, 250)
      })
    },

    methods: {
      ...mapActions([
        'loadProgramGuide',
        'loadProgramGuideCareers',
        'loadProgramCareerResult',
        'loadAlumniStreamRecommendations',
        'loadAdvisorStreamRecommendations',
        'resetProgramCareerResult',
        'loadGeoIds',
        'loadRegisterProspectiveStudent',
        'loadLogDashboardActivity',
        'updateShowAllOccupations',
        'loadProgramAlumniData'
      ]),
      continueToRegistrationForm () {
        this.newProspectError = ''
        if (this.newForm.eMail.length < 5 || !this.reg.test(this.newForm.eMail)) {
          this.newProspectError = 'Please enter a valid email.'
        } else {
          this.showRestOfTheForm = true
        }
      },
      showDemoWidgetMessage () {
        this.demoWidgetMessage = true
      },
      async registerProspectiveStudent () {
        this.newProspectError = ''
        if ((this.newForm.eMail.length > 0 && !this.reg.test(this.newForm.eMail)) || (this.newForm.eMail.length > 0 && this.newForm.eMail.length < 5)) {
          this.newProspectError = 'Please enter a valid email.'
        } else if (this.newForm.eMail.length > 0) {
          this.newProspectError = ''
          this.newForm.major1 = this.programGuideCode
          this.newForm.major1CipCode = this.cipCode
          this.newForm.major1Title = this.majorTitle
          let institutionId = this.institutionId
          if (this.newForm.firstName.length < 1) {
            this.newForm.firstName = 'Guest'
          }
          if (this.newForm.lastName.length < 1) {
            this.newForm.lastName = 'Guest'
          }
          this.$refs.loadingModal.show()
          this.loadLogDashboardActivity({action: 'submitProspectiveStudentForm', page: 'programCareerProspectsWidget', link: '', programCipCode: this.cipCode, programCode: this.programGuideCode})
          let response = await this.loadRegisterProspectiveStudent({prospectiveStudentForm: this.newForm, learningSpaceId: institutionId})
          if (response && response.data === 'duplicate_email_value') {
            this.$refs.loadingModal.hide()
            this.$refs.newFormModal.doShow()
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Email already exists!'
            })
            this.newProspectError = 'Email already used. Please use the email link that was sent to you to continue or click on <a href="https://pragyasystems.com/vue/#/login" target="_blank">login</a>.'
            this.newForm.eMail = ''
            this.showRestOfTheForm = false
          } else if (response && response.status === 200) {
            this.showThankYouPopup()
            this.newForm = {
              eMail: '',
              firstName: '',
              lastName: '',
              major1: '',
              major1CipCode: '',
              major1Title: '',
              selectedTerm: null,
              status: null,
              action: null
            }
            this.showRestOfTheForm = false
            /*
            let verifyUrl = window.location.origin + '/vue/#/verify?email=' + this.newForm.eMail
            window.open(verifyUrl, '_blank')
            this.$refs.newFormModal.hide()
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Please check your email for instructions!'
            })
            */
            this.$root.$emit('bv::hide::modal', 'webWidgetLoadingModal')
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Error! Please try again!'
            })
          }
          this.$refs.loadingModal.hide()
        } else {
          if (this.accordionCareerIndex) {
            this.collapseCareer(this.accordionCareerIndex)
          }
          this.$refs.newFormModal.hide()
          this.newForm = {
            eMail: '',
            firstName: '',
            lastName: '',
            major1: '',
            major1CipCode: '',
            major1Title: '',
            selectedTerm: null,
            status: null,
            action: null
          }
          this.showRestOfTheForm = false
          this.demoWidgetMessage = false
        }
      },
      showThankYouPopup () {
        this.$refs.thankYouModal.show()
        $('.usr_verification_popup_thankyou').removeClass('showAtTop')
        $('.usr_verification_popup_thankyou').removeClass('showAtBottom')
        $('.usr_verification_popup_thankyou').addClass('showAtTop')
      },
      closeThankYouModalBox () {
        this.$root.$emit('bv::hide::modal', 'userVerificationPopupThankYou')
      },
      toggleShowOccupations () {
        this.updateShowAllOccupations(!this.showAllOccupations)
      },
      getRandomInt (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min)
      },
      callDrawNeedle (el, value) {
        if (!document || !document.getElementById(el)) return
        let canvas = document.getElementById(el).childNodes[1]
        if (canvas) {
          let needleHeight = this.isWidgetAdminDash ? 50 : 25
          if (value && value < -10) {
            this.drawNeedle(canvas, needleHeight, -170 * Math.PI / 180)
          } else if (value && value >= -10 && value < -5) {
            this.drawNeedle(canvas, needleHeight, -150 * Math.PI / 180)
          } if (value && value >= -5 && value < 0) {
            this.drawNeedle(canvas, needleHeight, -130 * Math.PI / 180)
          } else if (value && value >= 0 && value < 5) {
            if (value === '0.0') {
              this.drawNeedle(canvas, needleHeight, -125 * Math.PI / 180)
            } else {
              this.drawNeedle(canvas, needleHeight, -110 * Math.PI / 180)
            }
          } else if (value && value >= 5 && value < 10) {
            this.drawNeedle(canvas, needleHeight, -90 * Math.PI / 180)
          } else if (value && value >= 10 && value < 15) {
            this.drawNeedle(canvas, needleHeight, -70 * Math.PI / 180)
          } else if (value && value >= 15 && value < 20) {
            this.drawNeedle(canvas, needleHeight, -50 * Math.PI / 180)
          } else if (value && value >= 20 && value < 25) {
            this.drawNeedle(canvas, needleHeight, -30 * Math.PI / 180)
          } else if (value && value >= 25) {
            this.drawNeedle(canvas, needleHeight, -10 * Math.PI / 180)
          }
        }
      },
      drawNeedle (canvas, radius, radianAngle) {
        var ctx = canvas.getContext('2d')
        var cw = canvas.offsetWidth
        var ch = canvas.offsetHeight
        var cx = cw / 2
        var cy = ch - (ch / 4)

        ctx.translate(cx, cy)
        ctx.rotate(radianAngle)
        ctx.beginPath()
        ctx.moveTo(0, -2)
        ctx.lineTo(radius, 0)
        ctx.lineTo(0, 2)
        ctx.fillStyle = 'rgba(100, 100, 100, 1)'
        ctx.fill()
        ctx.rotate(-radianAngle)
        ctx.translate(-cx, -cy)
        ctx.beginPath()
        ctx.arc(cx, cy, 3, 0, Math.PI * 2)
        ctx.fill()
      },
      async loadDataForProgramGuideCareerProspects () {
        await this.loadGeoIds()
        let locationParam = ''
        this.selectedDataInfo = 'US'
        if (this.state || this.msa) {
          if (this.state) {
            // set selectedState
            if (this.geoIdMap.stateGeoIds[this.state]) {
              this.selectedState = this.geoIdMap.stateGeoIds[this.state]
              this.selectedDataInfo = this.selectedState
              this.disableSelectState = true
            }
            locationParam = 'state:' + this.state
          } else if (this.msa) {
            // set selectedMetroArea
            if (this.geoIdMap.msaGeoIds[this.msa]) {
              this.selectedMetroArea = this.geoIdMap.msaGeoIds[this.msa]
              this.selectedDataInfo = this.selectedMetroArea
              this.disableSelectMetroArea = true
            }
            locationParam = 'msa:' + this.msa
          }
        }
        await this.loadProgramGuideCareers({ cipCode: this.cipCode, code: this.programGuideCode, showAllOccupations: this.showAllOccupations, locationParam: locationParam })

      },
      showFloatingFilterSection () {
        $('.fix_pg_tabs .filters_section').css('display', 'block')
      },
      hideFloatingFilterSection () {
        $('.fix_pg_tabs .filters_section').css('display', 'none')
      },
      showSalaryBoostSkills () {
        $('#careerDetailsSkills').addClass('show_boost_skills_only')
      },
      showAllSkills () {
        $('#careerDetailsSkills').removeClass('show_boost_skills_only')
      },
      closeNoResultModal () {
        this.selectedState = ''
        this.selectedMetroArea = ''
        this.$refs.noResultReturnedModal.hide()
      },
      checkForCompanyName (companyName) {
        if (companyName === '[Unknown]') {
          return 'Others'
        }
        return companyName
      },
      setTitleInitials (entityTitle) {
        let getTitleInitials = entityTitle.match(/\b(\w)/g)
        return getTitleInitials.join('')
      },
      setTitleBoxWidth (entityTitle, entityId) {
        let getTitleInitials = entityTitle.match(/\b(\w)/g)
        if (getTitleInitials.length < 3) {
          $('#' + entityId).addClass('txt_bx_' + getTitleInitials.length)
        }
        return entityId
      },
      setThumbnailBgColor (entityId) {
        let getNumricValue = entityId.replace(/[^0-9]/g, '')
        return '#' + getNumricValue.slice((getNumricValue.length - 8), (getNumricValue.length - 2))
      },
      updateTitleHeight (index) {
        let titleContainerHeight = $('#entityName_' + index).height()
        if (titleContainerHeight > 30) {
          $('#entityDesc_' + index).addClass('srt_desc')
        }
      },
      addCommaInNumber (numValue) {
        if (numValue && numValue.length > 0) {
          let numericValue = Math.floor(numValue)
          return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
        return numValue
      },
      formatNumericVal (numValue) {
        let numericValue = Math.floor(numValue)
        return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      formatOptionsForVSelect (map) {
        let formatted = []
        Object.keys(map).sort().forEach((key, i) => {
          formatted.push({id: key, label: map[key]})
        })
        formatted.sort((a, b) => (a.label >= b.label) ? 1 : -1)
        return formatted
      },
      resetData () {
        // this ensures the original program guide object info binds to the ui
        this.targetOccupationItems = []
        this.topCompaniesItems = []
        this.topSkillsItems = []
        this.resetProgramCareerResult()
        if (!this.disableSelectState && !this.disableSelectMetroArea) {
          this.selectedDataInfo = 'US'
        }
      },
      getCoursePlanningPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getCoursePlanningPackage(packages)
      },
      hasLaborData (career) {
        if (!career) {
          return false
        }
        return career.targetOccupations || career.topPostingCompanies || career.topSkills
      },
      showNewFormPopup (popupPosition, careerIndex) {
        this.loadLogDashboardActivity({action: 'unlockCompaniesSkills', page: 'programCareerProspectsWidget', link: '', programCipCode: this.cipCode, programCode: this.programGuideCode})
        this.$refs.newFormModal.doShow()
        $('.usr_verification_popup').removeClass('showAtTop')
        $('.usr_verification_popup').removeClass('showAtBottom')
        $('.usr_verification_popup').addClass(popupPosition)
        this.accordionCareerIndex = careerIndex ? careerIndex : null
      },
      closeModalBox () {
        if (this.accordionCareerIndex) {
          this.collapseCareer(this.accordionCareerIndex)
        }
        this.$refs.newFormModal.hide()
        this.newForm = {
          eMail: '',
          firstName: '',
          lastName: '',
          major1: '',
          major1CipCode: '',
          major1Title: '',
          selectedTerm: null,
          status: null,
          action: null
        }
        this.showRestOfTheForm = false
        this.demoWidgetMessage = false
      },
      exploreRegionalDataClicked () {
        this.newForm.action = 'ExploreRegionalData'
        this.showNewFormPopup('showAtTop')
      },
      fullCareerReportClicked (socCode) {
        this.newForm.action = 'FullCareerReport'
        this.newForm.socCode = socCode
        this.showNewFormPopup('showAtTop')
      },
      moreCompaniesClicked () {
        this.newForm.action = 'OtherCompanies'
        this.showNewFormPopup('showAtTop')
      },
      moreCareersClicked () {
        this.newForm.action = 'OtherCareers'
        this.showNewFormPopup('showAtTop')
      },
      askAdvisor () {
        this.newForm.status = 'Asked Advisor'
        this.showNewFormPopup('showAtTop')
      },
      isCareerClickExhausted (career) {
        this.clickCount++
        let retVal = false
        let socCode = career.code
        let clickInfo = Vue.$cookies.get('widget_career_clicks') || JSON.parse(localStore.getItem('widget_career_clicks')) || {}
        let socCodes = clickInfo[this.cipCode]
        if (!socCodes) {
          socCodes = [socCode]
        } else {
          if (!socCodes.includes(socCode)) {
            if (socCodes.length < 2) {
              socCodes.push(socCode)
            } else {
              retVal = true
            }
          }
        }
        clickInfo[this.cipCode] = socCodes
        Vue.$cookies.set('widget_career_clicks', clickInfo)
        localStore.setItem('widget_career_clicks', JSON.stringify(clickInfo))
        if (!retVal && this.clickCount > 2 && socCodes.length < 2) {
          retVal = true
        }
        return retVal
      },
      expandCareer (i, career) {
        $('.accordion-sec').removeClass('active')
        if (this.isCareerClickExhausted(career)) {
          this.newForm.action = 'ThirdCareer'
          this.newForm.socCode = career.code
          this.showNewFormPopup('showAtTop', i)
        } else {
          $('#accordionSec_' + i).addClass('active')
          setTimeout(() => {
            $('#detail-' + i).addClass('show')
            $('#detail-' + i).css('display', 'block')
          }, 100)
        }
      },
      collapseCareer (i) {
        this.accordionCareerIndex = null
        $('#accordionSec_' + i).removeClass('active')
        $('#detail-' + i).css('display', 'none')
        $('#detail-' + i).removeClass('show')
        // $('#info-' + i).removeClass('d-none')
      },
      getThumbnailURI (code) {
        return 'https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/soc-' + code + '---00.svg'
      },
      getMoreLessLabel () {
        let label = ''
        if ($('#biography').hasClass('description')) {
          label = 'more'
        } else {
          label = 'less'
        }
        return label
      },
      expandCollapseBio () {
        $('#biography').toggleClass('description')
        if ($('#biography').hasClass('description')) {
          $('#more-less').text('more')
        } else {
          $('#more-less').text('less')
        }
      },
      getClassOf (person) {
        if (person.educationInfoList && person.educationInfoList.length > 0) {
          return ' - Class of ' + person.educationInfoList[0].classOf
        }
        return ''
      }
    },
    computed: {
      ...mapState({
        'programGuide': state => state.programguide.programGuideObject,
        'showAllOccupations': state => state.programguide.showAllOccupations,
        'careersObject': state => state.programguide.careers,
        'careerResult': state => state.programguide.careerResult,
        'packages': state => state.institution.packages,
        'geoIdMap': state => state.career.geoIdMap,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'termMapWithCutOffDate': state => state.institution.termMapWithCutOffDate
      }),
      isContinueEnabled () {
        return (this.newForm.eMail.length > 0)
      },
      isUnlockEnabled () {
        return (this.newForm.eMail.length > 0)
      },
      showAskAdvisorOnWidgetIsEnabled () {
        let askAdvisorFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_ASK_ADVISOR_ON_WIDGET]
        return askAdvisorFeature && askAdvisorFeature.enabled
      },
      showAlumniDataOnWidgetIsEnabled () {
        let showAlumniDataFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_ALUMNI_DATA_ON_WIDGET_FEATURE_ID]
        return showAlumniDataFeature && showAlumniDataFeature.enabled
      },
      showCareerEmoloyerJob (){
        return this.alumniData && (this.alumniData.topCareerTitle || this.alumniData.topCompanyTitle  || this.alumniData.totalHireLastYearHire)
      },
      availableTerms () {
        let terms = []
        let entries = Object.entries(this.termMapWithCutOffDate)
        if (entries && entries.length > 0) {
          terms.push({value: null, text: 'Select a Term'})
          for (const [key, data] of entries) {
            if (key) {
              terms.push({value: key, text: data.label})
            }
          }
          return terms
        }
        return []
      },
      showTermOnWidgetIsEnabled () {
        let termFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_TERM_ON_WIDGET]
        return termFeature && termFeature.enabled
      },
      showPhoneNumberOnWidgetIsEnabled () {
        let phoneNumberFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_PHONE_NUMBER_ON_WIDGET]
        return phoneNumberFeature && phoneNumberFeature.enabled
      },
      showEducationLevelOnWidgetEnabled () {
        let educationLevelOnWidgetFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_EDUCATION_LEVEL_ON_WIDGET]
        return educationLevelOnWidgetFeature && educationLevelOnWidgetFeature.enabled
      },
      showEducationLevelEnabled () {
        let educationLevelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_EDUCATION_LEVEL]
        return educationLevelFeature && educationLevelFeature.enabled
      },
      isEMSIFeatureEnabled () {
        let emsiFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_EMSI_SOURCE]
        return emsiFeature && emsiFeature.enabled
      },
      isBGTFeatureEnabled () {
        let bgtFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_BGT_SOURCE]
        return bgtFeature && bgtFeature.enabled
      },
      showCityStateFilterOnWidget () {
        let showCityStateFilterOnWidgetFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_CITY_STATE_FILTER_ON_WIDGET]
        return showCityStateFilterOnWidgetFeature && showCityStateFilterOnWidgetFeature.enabled
      },
      unlockCompaniesSkillsOnWidget () {
        let unlockCompaniesSkillsOnWidgetFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.UNLOCK_COMPANIES_SKILLS_ON_WIDGET]
        return unlockCompaniesSkillsOnWidgetFeature && unlockCompaniesSkillsOnWidgetFeature.enabled
      },
      companiesTreeMapData () {
        if (this.formattedCareer && this.formattedCareer.topPostingCompanies) {
          let jsonData = {
            name: ' ',
            children: []
          }
          let length = this.formattedCareer.topPostingCompanies.length
          let count = (length < 4) ? length : 4
          for (var i = 0; i < count; i++) {
            let parsedCareer = JSON.parse(this.formattedCareer.topPostingCompanies[i])
            let name = parsedCareer.name
            let value = parsedCareer.unique_postings
            if (parsedCareer.name === '[Unknown]') {
              name = 'Others'
            }
            if (parsedCareer.name === 'ACCENTURE, INC.') {
              name = 'Accenture'
            }
            if (parsedCareer.name === 'Robert Half International Inc.') {
              name = 'Robert Half'
            }
            let careerObj = {
              name: name,
              value: value
            }
            jsonData.children.push(careerObj)
          }
          return jsonData
        }
        return {}
      },
      skillsTreeMapData () {
        if (this.formattedCareer && this.formattedCareer.topSkills) {
          let jsonData = {
            name: 'Top Skills',
            children: []
          }
          /*
          this.formattedCareer.topSkills.forEach((career) => {
            let parsedCareer = JSON.parse(career)
            let careerObj = {
              name: parsedCareer.name,
              value: parsedCareer.unique_postings
            }
            jsonData.children.push(careerObj)
          })
          */
          let length = this.formattedCareer.topSkills.length
          let count = (length < 4) ? length : 4
          for (var i = 0; i < count; i++) {
            let parsedCareer = JSON.parse(this.formattedCareer.topSkills[i])
            let name = parsedCareer.name
            if (name === 'JavaScript (Programming Language)') {
              name = 'JavaScript'
            }
            if (name === 'Java (Programming Language)') {
              name = 'Java'
            }
            if (name === 'Agile Software Development') {
              name = 'Agile'
            }
            let careerObj = {
              name: name,
              value: parsedCareer.unique_postings
            }
            jsonData.children.push(careerObj)
          }
          return jsonData
        }
        return {}
      },
      incomeScatterData () {
        if (this.formattedCareers) {
          let data = {
            labels: [],
            datasets: [
              {
                label: '',
                fill: false,
                borderWidth: 0,
                borderColor: 'rgb(245, 245, 245)',
                backgroundColor: 'rgb(245, 245, 245)',
                pointRadius: 14,
                pointHoverRadius: 16,
                pointBackgroundColor: '#157099',
                pointBorderWidth: 2,
                pointBorderColor: '#014966',
                data: []
              }
            ]
          }
          this.formattedCareers.forEach((career) => {
            let dataPoint = {
              x: career.medianHourlyEarning,
              y: this.getRandomInt(0, 1)
            }
            data.datasets[0].data.push(dataPoint)
            data.labels.push(career.name)
          })
          return data
        }
        return {}
      },
      jobPostingsPieData () {
        let data = {
          // labels: ['Job Postings'],
          datasets: [
            {
              label: 'Job Postings',
              backgroundColor: '#8db350',
              data: []
            }
          ]
        }
        if (this.formattedCareer && this.formattedCareer.aggregatedLastYearJob) {
          data.datasets[0].data.push(this.formattedCareer.aggregatedLastYearJob)
        }
        return data
      },
      growthPieData () {
        let data = {
          // labels: ['Less than 0%', '0-15%', 'Greater than 15%'],
          datasets: [
            {
              labels: 'Growth',
              backgroundColor: ['#f5b518', '#9fc958', '#0a7714'],
              data: [15, 15, 15]
            }
          ]
        }
        if (this.formattedCareer && this.formattedCareer.aggregatedGrowthPercentage) {
          return data
        }
        return {}
      },
      medianIncomePieData () {
        let data = {
          // labels: ['Median Income'],
          datasets: [
            {
              label: 'Median Income',
              backgroundColor: '#8db350',
              data: []
            }
          ]
        }
        if (this.formattedCareer && this.formattedCareer.aggregatedMedianHourlyEarning) {
          data.datasets[0].data.push(this.formattedCareer.aggregatedMedianHourlyEarning)
        }
        return data
      },
      formattedCareers () {
        let formattedCareers = []
        let careers = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
        if (!this.hasLaborData(careers)) {
          return []
        }
        careers.targetOccupations.forEach((career) => {
          let formatted = JSON.parse(career)
          let companies = []
          formatted.companies.forEach((company) => {
            companies.push(JSON.parse(company))
          })
          formatted.companies = companies
          if (!formatted.thumbnailUrl) {
            formatted.thumbnailUrl = this.getThumbnailURI(formatted.code)
          }
          formattedCareers.push(formatted)
        })
        // DO not sort if disable
        if(!careers.disableCareerSort) {
          formattedCareers = formattedCareers.sort((a, b) => (parseFloat(a.medianHourlyEarning) <= parseFloat(b.medianHourlyEarning)) ? 1 : -1)
        }
        return formattedCareers
      },
      formattedCareer () {
        let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
        if (!this.hasLaborData(formattedCareer)) {
          return {}
        }
        this.resetData()
        formattedCareer.targetOccupations.forEach((career, i) => {
          let curr = JSON.parse(career)
          if (i === 0) {
            formattedCareer.timeframe = curr.timeframe
            formattedCareer.endYear = curr.year
            formattedCareer.startYear = formattedCareer.endYear - 10
            formattedCareer.tenYearOldJobTitle = curr.tenYearOldJobTitle
          }
          let tenYearOldJobTitle = formattedCareer.tenYearOldJobTitle
          let growthTitle = 'Growth (' + formattedCareer.timeframe + ')'
          let currItem = {
            'Occupation': curr.name,
            'Annual Openings': curr.annualOpening,
            'Median Earnings': curr.medianHourlyEarning,
            'Education': curr.education,
            'code': curr.code
          }
          currItem[tenYearOldJobTitle] = curr.tenYearOldJob
          currItem[growthTitle] = curr.growth
          // if (parseFloat(curr.growth) > 10) {
          this.targetOccupationItems.push(currItem)
          // }
        })
        // DO not sort if disable
        if(!formattedCareer.disableCareerSort) {
          this.targetOccupationItems = this.targetOccupationItems.sort((a, b) => (parseFloat(a['Median Earnings']) <= parseFloat(b['Median Earnings'])) ? 1 : -1)
        }

        if (!formattedCareer.topPostingCompanies) {
          return formattedCareer
        }

        formattedCareer.topPostingCompanies.forEach((company, i) => {
          let curr = JSON.parse(company)
          let tenYearPostingTitle = 'Total/Unique (' + formattedCareer.timeframe + ')'
          let currItem = {'Company': curr.name}
          currItem[tenYearPostingTitle] = curr.total_postings + ' / ' + curr.unique_postings
          currItem['Total'] = curr.total_postings
          currItem['Unique'] = curr.unique_postings
          currItem['Posting Intensity'] = (Math.round(curr.posting_intensity)) + ':1'
          this.topCompaniesItems.push(currItem)
        })
        this.topCompaniesItems = this.topCompaniesItems.sort((a, b) => (Number(a.Total) <= Number(b.Total)) ? 1 : -1)
        if (!formattedCareer.topSkills) {
          return formattedCareer
        }

        formattedCareer.topSkills.forEach((skill, i) => {
          let curr = JSON.parse(skill)
          let currItem = {'Skill': curr.name,
            'Postings_with_Skill': curr.unique_postings,
            'Types': curr.types,
            'Marginal_Value': curr.marginal_value }
          this.topSkillsItems.push(currItem)
        })
        this.topSkillsItems = this.topSkillsItems.sort((a, b) => (Number(a.Postings_with_Skill) <= Number(b.Postings_with_Skill)) ? 1 : -1)
        return formattedCareer
      },
      formattedGeoIdMap () {
        let formattedMap = {}
        let map = this.geoIdMap

        if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
          formattedMap.stateGeoIds = this.formatOptionsForVSelect(map.stateGeoIds)
          formattedMap.msaGeoIds = this.formatOptionsForVSelect(map.msaGeoIds)
          formattedMap.countyGeoIds = this.formatOptionsForVSelect(map.countyGeoIds)
        }
        return formattedMap
      },
      labelsToCodesMap () {
        let map = this.geoIdMap
        let formattedMap = {}
        if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
          formattedMap.stateGeoIds = _.invert(map.stateGeoIds)
          formattedMap.msaGeoIds = _.invert(map.msaGeoIds)
          formattedMap.countyGeoIds = _.invert(map.countyGeoIds)
        }
        return formattedMap
      },
      targetOccupationFields () {
        let fields = ['Occupation']
        if (this.formattedCareer.targetOccupations && this.formattedCareer.targetOccupations.length > 0) {
          let curr = JSON.parse(this.formattedCareer.targetOccupations[0])
          fields.push((curr.tenYearOldJobTitle))
          fields.push('Annual Openings')
          fields.push('Median Earnings')
          fields.push('Growth (' + curr.timeframe + ')')
          return fields
        } else {
          return []
        }
      },
      topCompaniesFields () {
        let fields = ['Company']
        if (this.formattedCareer.targetOccupations && this.formattedCareer.targetOccupations.length > 0) {
          let curr = JSON.parse(this.formattedCareer.targetOccupations[0])
          fields.push('Total/Unique (' + curr.timeframe + ')')
          fields.push('Posting Intensity')
          return fields
        } else {
          return []
        }
      },
      spotlightAlumni () {
        if (this.alumniData.spotlightPerson && this.alumniData.spotlightPerson.length > 0) {
          return this.alumniData.spotlightPerson[0]
        }
        return null
      }
    },
    watch: {
    }
  }
</script>
<style scoped>
  .frm_btn_col .btn {
    margin-top: 32px;
    height: 40px;
  }
  .state .v-select .dropdown-toggle {
    background-color: #d0eaf4;
  }
  .city .v-select .dropdown-toggle {
    background-color: #ffebed;
  }
  .term-fld-label {
    text-align: left;
    margin-bottom: .5rem;
    font-size: 1.15rem;
    color: #323232;
    padding-left: .3rem;
  }
  .circle {
    height: 25px;
    width: 25px;
    border-radius: 50%;
    border: 1px solid #d3d3d3;
    line-height: 16px;
    text-align: center;
    cursor: pointer;
    font-size: 22px;
    margin-top: 15px;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  .alumni-career-label {
    background: #c1c1c1;
    border: 1px solid #c1c1c1;
    border-radius: 15px;
    margin-left: 25px;
    text-align: center !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/WidgetProgramGuideCareerProspectsDetail.vue